export default __webpack_public_path__ + "static/bmw-88081db77e7af11d698cb60c6888fe8d.png";